import { render } from "./AccountManager.vue?vue&type=template&id=67a38e5e"
import script from "./AccountManager.vue?vue&type=script&lang=js"
export * from "./AccountManager.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__